import CourseBaseReq from "./CourseBaseReq";

export default class CreateCourseReq extends CourseBaseReq {}
